import { Image } from 'react-native'
import { Images as foundationImages } from '@vfgroup-oneplatform/foundation/Components/Themes'

const Images = {
  chevronRightRed: foundationImages.ic_chevron_right_red,
  // Ebill
  background: Image.resolveAssetSource(
    require('./../Images/Background/app_bg.png'),
  ),
  chargeToBillDark: Image.resolveAssetSource(
    require('./../Images/Icons/chargeToBillDark.png'),
  ),
  downloadDark: Image.resolveAssetSource(
    require('./../Images/Icons/downloadDark.png'),
  ),
  tvDark: Image.resolveAssetSource(
    require('./../Images/Icons/tvDark.png'),
  ),
  mobileDark: Image.resolveAssetSource(
    require('./../Images/Icons/mobileDark.png'),
  ),
  routerDark: Image.resolveAssetSource(
    require('./../Images/Icons/routerDark.png'),
  ),
  parentalControlDark: Image.resolveAssetSource(
    require('./../Images/Icons/parentalControlDark.png'),
  ),
  greenTick: foundationImages.tickIcon,
  yellowTick: Image.resolveAssetSource(
    require('./../Images/Icons/partialPaid.png'),
  ),


  // Reward
  vf_logo: foundationImages.vfLogo,

  // Survey Screen
  survey_bg: Image.resolveAssetSource(
    require('./../Images/Background/survey-bg.jpg'),
  ),
  celebrate: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/celebrate.png'),
  ),
  tick: Image.resolveAssetSource(require('./../Images/Icons/HIFI/tick.png')),
  tick_white: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/tick_white.png'),
  ),

  // Product Card
  product_image_bg: Image.resolveAssetSource(
    require('./../Images/Background/productBg.png'),
  ),

  gift_box_unlocked: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/redeemed_unlocked_rewards.png'),
  ),
  favourite: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/favourite.png'),
  ),
  unfavourite: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/unfavourite.png'),
  ),
  vcoins_yellow: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/vcoins-line-yellow.png'),
  ),
  vcoins_white: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/vcoins-line-white.png'),
  ),
  vcoins_grey: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/vcoins-line-grey.png'),
  ),

  // Transactions Screen
  mobile: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/mobile.png'),
  ),
  price_tag: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/price_tag.png'),
  ),
  top_up: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/top_up.png'),
  ),
  info: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/info_white.png'),
  ),
  close: foundationImages.ic_close,

  // Product Screen
  pin_vodafone: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/pinVodafone.png'),
  ),
  info_black: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/info.png'),
  ),
  recharge: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/saving.png'),
  ),
  error: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/warning.png'),
  ),

  // Migration icons
  bulletList: Image.resolveAssetSource(
    require('./../Images/Migration-icons/bullet-list.png'),
  ),
  edit: Image.resolveAssetSource(
    require('./../Images/Migration-icons/edit.png'),
  ),
  mobileData: Image.resolveAssetSource(
    require('./../Images/Migration-icons/mobile-data.png'),
  ),
  phone: Image.resolveAssetSource(
    require('./../Images/Migration-icons/phone.png'),
  ),
  sim: Image.resolveAssetSource(
    require('./../Images/Migration-icons/sim.png'),
  ),
  mesages: Image.resolveAssetSource(
    require('./../Images/Migration-icons/sms-HIFI.png'),
  ),
  sms: Image.resolveAssetSource(
    require('./../Images/Migration-icons/sms.png'),
  ),
  tickConfirm: Image.resolveAssetSource(
    require('./../Images/Migration-icons/tick.png'),
  ),
  calendar: Image.resolveAssetSource(
    require('./../Images/Migration-icons/calendar.png'),
  ),
  money: Image.resolveAssetSource(
    require('./../Images/Migration-icons/money.png'),
  ),
  delete: Image.resolveAssetSource(
    require('./../Images/Migration-icons/delete.png'),
  ),
  warning: Image.resolveAssetSource(
    require('./../Images/Migration-icons/warning.png'),
  ),
  orderProcessing: Image.resolveAssetSource(
    require('./../Images/Migration-icons/orderProcessing.png'),
  ),

  // Migration images
  migrationBackground: Image.resolveAssetSource(
    require('./../Images/Migration-images/headerBackground.png'),
  ),
  idCardExample: Image.resolveAssetSource(
    require('./../Images/Migration-images/idCardExample.png'),
  ),
  vatNumberExample: Image.resolveAssetSource(
    require('./../Images/Migration-images/vatNumberExample.png'),
  ),
  userHIFI: Image.resolveAssetSource(
    require('./../Images/Migration-icons/user-HIFI.png'),
  ),
  idHIFI: Image.resolveAssetSource(
    require('./../Images/Migration-icons/id-HIFI.png'),
  )
}

export default Images
